import React from 'react';
import { ActionButton } from '../ActionButton';
import { MID_GRAY } from '@/styles/tokens';

interface PinGroupDrilldownProps {
  pinGroupId?: string;
  groups: Array<{ id: string; name: string; pinIds?: string[] }>;
  onAutoSend: (command: string) => void;
  onPreFill: (text: string) => void;
  onInjectMessage: (content: string) => void;
  onDone: () => void;
}

export const PinGroupDrilldown: React.FC<PinGroupDrilldownProps> = ({
  pinGroupId,
  groups,
  onAutoSend,
  onPreFill,
  onInjectMessage,
  onDone,
}) => (
  <>
    <div style={{ display: 'flex', alignItems: 'center', gap: '8px', margin: '8px 0' }}>
      <ActionButton variant="back" onClick={onDone}>
        ← Back
      </ActionButton>
      <span style={{ fontSize: '13px', color: MID_GRAY.DEFAULT }}>Choose a group:</span>
    </div>
    <div style={{ display: 'flex', flexWrap: 'wrap', gap: '6px' }}>
      {pinGroupId && (() => {
        const currentGroup = groups.find(g => g.id === pinGroupId);
        return currentGroup ? (
          <ActionButton
            key="remove-group"
            variant="destructive"
            onClick={() => {
              onAutoSend(`remove pin from ${currentGroup.name}`);
              onDone();
            }}
          >
            Remove from {currentGroup.name}
          </ActionButton>
        ) : null;
      })()}
      {groups
        .filter(g => g.id !== pinGroupId)
        .map(group => (
          <ActionButton
            key={group.id}
            onClick={() => {
              onAutoSend(`add pin to ${group.name}`);
              onDone();
            }}
          >
            {group.name}
          </ActionButton>
        ))}
      <ActionButton
        variant="dashed"
        onClick={() => {
          onDone();
          onPreFill('create group ');
          onInjectMessage('Type a group name and press Enter.');
        }}
      >
        + Create new group
      </ActionButton>
    </div>
  </>
);
